export const ROUTE_BASE_NAME = "logs";

export const ROUTE_NAMES = {
  List: `${ROUTE_BASE_NAME}.list`,
  LogsDriver: `${ROUTE_BASE_NAME}.logs.driver`,
  LogsDriverElog: `${ROUTE_BASE_NAME}.logs.driver.elog`,
  LogsDriverTransaction: `${ROUTE_BASE_NAME}.logs.driver.transaction`,
  LogsPrint: `${ROUTE_BASE_NAME}.logs.print`,
};
